export const supplementSampleAction = (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }